module.exports = __webpack_public_path__ + "assets/img/excel.25efb1e4.svg";